"use client"

import { CultureInfoMapBox } from "@/widgets/CultureInfoMapBox";

const MapPageView = () => {

    return (
        <>
            <CultureInfoMapBox/>
        </>
    )
}

export default MapPageView